import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput,
  DateInput,
  FileInput,
  FileField

} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";

const BillTypeForm = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <SimpleForm {...props}>
      <ReferenceInput
        // disabled={record.project ? true : false}
        validate={[required()]}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" label="ชื่อประเภทภาษาไทย" validate={[required()]} fullWidth />
      <TextInput source="name_en" label="ชื่อประเภทภาษาอังกฤษ" validate={[required()]} fullWidth />
      <TextInput source="name_jp" label="ชื่อประเภทภาษาญี่ปุ่น" validate={[required()]} fullWidth />
      <TextInput source="name_zh" label="ชื่อประเภทภาษาจีน" validate={[required()]} fullWidth />
      <TextInput source="key" validate={[required()]} fullWidth />
    </SimpleForm>
  );
};

export default BillTypeForm;



// WEBPACK FOOTER //
// ./src/components/billtype/BillTypeForm.js